import Dependencies from './utilities/dependencies';
import DependencyManager from './utilities/dependency-manager';
import HeaderMobile from './mobile/header';
import BookingLink from "./utilities/booking-link";
import initCollapse from "./utilities/collapse";

document.querySelectorAll('header.mobile-view').forEach(e => new HeaderMobile(e));

/**
 * Modules are loaded on demand: the chunk is only fetched once an element
 * matching the selector is about to enter the viewport.
 */
const moduleMap = {
	'.hero-element':                    () => import('./elements/hero'),
	'.blog-slider-element':             () => import('./elements/blog-slider'),
	'.content-row-element':             () => import('./elements/content-row'),
	'.faq-element':                     () => import('./elements/faqs'),
	'.features-element':                () => import('./elements/features'),
	'.info-row-element':                () => import('./elements/info-row'),
	'.offers-element':                  () => import('./elements/offers'),
	'.places-element':                  () => import('./elements/places'),
	'.room-element':                    () => import('./elements/room'),
	'.blog-element':                    () => import('./components/blog'),
	'.booking-search-form-wrapper':     () => import('./includes/booking-search-form'),
	'.gallery-wrapper':                 () => import('./includes/gallery'),
	'.info-box':                        () => import('./includes/info-box'),
	'header.desktop-view':              () => import('./includes/header'),
	'#revinate_contact_api_form':       () => import('./includes/revinate'),
	'.mosaic-content-dropdown':         () => import('./mosaic/mosaic-content-dropdown'),
	'.mosaic-item-hotel':               () => import('./mosaic/mosaic-hotel'),
	'.mosaic-item-text':                () => import('./mosaic/mosaic-item-text'),
	'.mosaic-offer':                    () => import('./mosaic/mosaic-offer'),
	'.mosaic-restaurant':               () => import('./mosaic/mosaic-restaurant'),
	'.mosaic-slider, .mosaic-item-gallery': () => import('./mosaic/mosaic-slider'),
	'a[href^="tel:"]':                  () => import('./utilities/tel-link'),
};

/**
 * Modules that must run regardless of visibility or scroll position. They either
 * sit in elements that are hidden by CSS (an IntersectionObserver never fires for
 * display: none), or are used by other modules and must exist before a click.
 */
const eagerSelectors = [
	'header.desktop-view',
	'.gallery-wrapper',
	'.info-box',
	'.mosaic-item-text',
	'a[href^="tel:"]',
];

const baseDependencies = [];

const baseReady = Promise.resolve();

initCollapse();

const initModule = (selector, element) => {
	Promise.all([moduleMap[selector](), baseReady])
		.then(([m]) => DependencyManager.initModule(m.default, element));
};

const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (!entry.isIntersecting) {
			return;
		}
		observer.unobserve(entry.target);
		Object.keys(moduleMap)
			.filter(selector => entry.target.matches(selector))
			.forEach(selector => initModule(selector, entry.target));
	});
}, {rootMargin: '200px'});

Object.keys(moduleMap).forEach(selector => {
	document.querySelectorAll(selector).forEach(element => {
		if (eagerSelectors.includes(selector)) {
			initModule(selector, element);
		} else {
			observer.observe(element);
		}
	});
});


const lazyLoadObserver = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			lazyLoadObserver.unobserve(entry.target);
			DependencyManager.loadScript(entry.target.dataset.lazyLoad);
		}
	});
}, {rootMargin: '1000px'});
document.querySelectorAll('[data-lazy-load]').forEach(e => lazyLoadObserver.observe(e));

new BookingLink();
